var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChevronDropdown = function SvgChevronDropdown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "4px",
    viewBox: "0 0 8 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF107") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tablet",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-copy",
    transform: "translate(-136.000000, -781.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(60.000000, 759.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1986693,22.6428508 C83.1986693,22.6964222 83.1718835,22.7566902 83.1317049,22.7968688 L80.0111655,25.9174082 C79.9709869,25.9575869 79.9107189,25.9843726 79.8571475,25.9843726 C79.803576,25.9843726 79.743308,25.9575869 79.7031294,25.9174082 L76.58259,22.7968688 C76.5424114,22.7566902 76.5156256,22.6964222 76.5156256,22.6428508 C76.5156256,22.5892793 76.5424114,22.5290113 76.58259,22.4888327 L76.9174118,22.1540109 C76.9575904,22.1138323 77.0111619,22.0870465 77.0714298,22.0870465 C77.1250013,22.0870465 77.1852693,22.1138323 77.2254479,22.1540109 L79.8571475,24.7857105 L82.488847,22.1540109 C82.5290256,22.1138323 82.5892936,22.0870465 82.6428651,22.0870465 C82.6964366,22.0870465 82.7567045,22.1138323 82.7968831,22.1540109 L83.1317049,22.4888327 C83.1718835,22.5290113 83.1986693,22.5892793 83.1986693,22.6428508 Z",
    id: "\\uF107"
  }))))));
};
export default SvgChevronDropdown;